import Image from 'next/image';
import { useTranslations } from 'next-intl';

import BenefitIcon from '@/fo/icons/base/doctor/benefit.svg';
import PhotoIcon from '@/fo/icons/base/doctor/photo.svg';
import { utilPluralize } from '@/fo/util/pluralize';

import { Clinic, DoctorProperties } from '../../types';

import { styles } from './DoctorCard.styles';

export interface DoctorCardProps {
  doctor: DoctorProperties;
  selectedClinic?: Clinic | null;
}

export function DoctorCard({ doctor }: DoctorCardProps) {
  const slots = styles();
  const address = doctor.clinics?.find(
    (clinic) => clinic.address === doctor.clinic_address
  );

  const t = useTranslations();
  const pluralizeYears = utilPluralize({
    one: t('pluralize.years.one'),
    few: t('pluralize.years.few'),
    many: t('pluralize.years.many')
  });
  const currentYear = new Date().getFullYear();

  return (
    <div className={slots.base()}>
      <div className={slots.top()}>
        <div className={slots.photo()}>
          {doctor.photo ? (
            <Image
              src={doctor.photo}
              height={148}
              width={148}
              alt={doctor.full_name}
              className={slots.photoImg()}
            />
          ) : (
            <PhotoIcon className={slots.photoImg()} />
          )}
        </div>
        <div className={slots.content()}>
          <div className={slots.info()}>
            <div className={slots.name()}>{doctor.full_name}</div>
            <div className={slots.subtitle()}>
              {doctor.occupation?.join(', ')}
            </div>
            <div className={slots.experience()}>
              {doctor.qualification && <span>{doctor.qualification}</span>}
              {doctor.seniority && (
                <span>
                  {' '}
                  / {t('seniority')} {currentYear - Number(doctor.seniority)}{' '}
                  {pluralizeYears(currentYear - Number(doctor.seniority))}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      {address && (
        <div className={slots.address()}>
          <div className={slots.addressTitle()}>
            <span className={slots.addressIcon()}>
              <BenefitIcon />
            </span>
            {address.name}
          </div>
          <p className={slots.addressText()}>{address.address}</p>
          {address.telephone && (
            <a
              href={`tel:${address.telephone}`}
              className={slots.phone()}
            >
              {address.telephone}
            </a>
          )}
        </div>
      )}
    </div>
  );
}
